/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBurstingDefinition = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7.529 3.145a1 1 0 0 0-1.037 0l-5.01 3.037A1 1 0 0 0 1 7.037v4.859a1 1 0 0 0 .482.855l5.01 3.036a1 1 0 0 0 1.037 0L11 13.683v2.975a1 1 0 0 0 .482.855l5.01 3.037a1 1 0 0 0 1.037 0l5.011-3.037a1 1 0 0 0 .482-.855v-4.86a1 1 0 0 0-.482-.854l-5.01-3.037a1 1 0 0 0-1.037 0l-3.472 2.104V7.037a1 1 0 0 0-.482-.855zM6.01 10.637v2.52L3 11.332v-2.52zm5.01.695-3.01 1.825v-2.52l3.01-1.825zm-.93-4.295L7.01 8.904 3.928 7.037 7.01 5.169zm5.92 8.362v2.52L13 16.094v-2.52zm5.01.696-3.01 1.824V15.4l3.01-1.825zm-.929-4.296-3.08 1.867L13.93 11.8l3.081-1.867z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBurstingDefinition as BurstingDefinition };
